module.exports = __webpack_public_path__ + "img/4b12cd369c60347ad39da8317c943c56.png";